import { Users, Star, Zap, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const JoinAdventure = () => {
  return (
    <section id="join-adventure" className="py-20 bg-gradient-to-r from-primary-50 to-purple-50 dark:from-primary-500/10 dark:to-purple-500/10 relative">
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.02)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:50px_50px]"></div>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Join the Fab43 Adventure
          </h2>
          <p className="text-xl text-gray-700 dark:text-white/70 leading-relaxed">
            Devenez membre d'une communauté dynamique d'innovateurs, de créateurs et d'entrepreneurs. 
            Transformez vos idées en réalité avec notre écosystème de support complet.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <div className="w-16 h-16 bg-primary-100 dark:bg-white/10 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
              <Users className="h-8 w-8 text-primary-600 dark:text-white" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Communauté d'Abord</h3>
            <p className="text-gray-600 dark:text-white/70">Rejoignez un réseau diversifié d'innovateurs et de créateurs</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-primary-100 dark:bg-white/10 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
              <Star className="h-8 w-8 text-primary-600 dark:text-white" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Accompagnement d'Expert</h3>
            <p className="text-gray-600 dark:text-white/70">Apprenez des professionnels de l'industrie et des mentors</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-primary-100 dark:bg-white/10 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
              <Zap className="h-8 w-8 text-primary-600 dark:text-white" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Innovation Rapide</h3>
            <p className="text-gray-600 dark:text-white/70">Accédez à des outils et technologies de pointe</p>
          </div>
        </div>

        <div className="bg-white/90 dark:bg-white/5 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-gray-200 dark:border-white/10 shadow-sm text-center">
          <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Prêt à Commencer Votre Aventure?</h3>
          <p className="text-gray-600 dark:text-white/70 mb-8 max-w-2xl mx-auto">
            Que vous soyez étudiant, entrepreneur ou professionnel créatif, Fab43 offre l'environnement parfait pour donner vie à vos idées.
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link
              to="/contact"
              className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 flex items-center justify-center space-x-2"
            >
              <span>Commencer Aujourd'hui</span>
              <ArrowRight className="h-5 w-5" />
            </Link>
            <Link
              to="/services"
              className="border-2 border-primary-600 text-primary-600 dark:border-primary-500 dark:text-primary-400 px-8 py-4 rounded-full font-semibold hover:bg-primary-50 dark:hover:bg-primary-500/10 transition-all duration-300"
            >
              <span>Explorer Nos Services</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinAdventure;
